import { TransactionClick } from './transaction-click';

export { TransactionClick };
